module.exports = __webpack_public_path__ + "static/fabric-table-vscroll-7fdbce9da2421316e92f8c69c701f439.png";